import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AccessControlService} from './../../services/access-control.service';
import {USERTYPE} from '../../enum/roles.enum';
import {FormGroup, FormControl, NgForm} from '@angular/forms';
import {Client} from '../../model/client.modals';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {map} from 'rxjs/operators';
import {AlertService} from '../../services/alert.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-sms-usage',
  templateUrl: './sms-usage.component.html',
  styleUrls: ['./sms-usage.component.css']
})
export class SmsUsageComponent implements OnInit {
  dataSource: MatTableDataSource<any>;
  clientId: any;
  selectedClientId: any;
  isLoading: boolean;
  noData: any;
  clientList: any;
  clientData: any;
  consumedSMS: number;
  fromDate: Date;
  toDate: Date;
  model: any = {};
  maxDate = new Date();
  inputReadonly = true;

  clients: { username: string, _id: string }[];
  @ViewChild('TABLE') table: ElementRef;
  @ViewChild('smsForm') public smsForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['phone', 'smsBody', 'sent'];

  client = new Client();
  isSMSenable: boolean;

  constructor(
    private alertService: AlertService,
    private AccessService: AccessControlService,
    private accessControlService: AccessControlService,
  ) {
  }

  ngOnInit() {
    this.clientId = localStorage.getItem('org_id');
    this.fetchClientList();
    const date = new Date();
    this.model.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.model.toDate = new Date();
   // this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
  }

  submit(form: NgForm) {
    if (!this.smsForm.valid) {
      return;
    }

    this.getSMSUsage();
  }

  applyFilter(event: Event) {
    this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
    let filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
   /* if (filterValue.includes('sent')) {
      filterValue = 'true';
    }
    if (filterValue.includes('failed')) {
      filterValue = 'false';
    }*/
    this.dataSource.filter = filterValue;
  }
  getSMSUsage() {
    const clientId = this.model.exisitingUser;
    this.selectedClientId = this.model.exisitingUser;
    this.fromDate = this.model.fromDate;
    this.toDate = this.model.toDate;
    // tslint:disable-next-line:triple-equals

    this.AccessService.getSMS_usage({clientId, fromDate: this.fromDate, toDate: this.toDate}).subscribe((res: any) => {
      this.clientData = res.clientDetails;
      this.isSMSenable = res.clientDetails.smsEnabled ? true : false;
      this.consumedSMS = res.countDocs;
      this.isLoading = false;
      this.dataSource = new MatTableDataSource<any>(res.docs);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  fetchClientList() {
    this.accessControlService.getOrganizationClients(this.clientId, 0, Number.MAX_SAFE_INTEGER).subscribe((response: any) => {
      this.clientList = response.data;
      this.clients = Array.from(new Set<{ username: string, _id: string }>(response.data.map(x => {
        if (x.type !== USERTYPE.SUBCLIENT) {
          return {username: x.username, _id: x._id};
        }
        // tslint:disable-next-line:triple-equals
      }))).filter(x => typeof x == 'object');
    });
  }

  onFactorChange($event: boolean, sms: string) {
    this.accessControlService.updateClient_sms_functionality({smsEnabled: $event}, this.selectedClientId).subscribe((response: any) => {
      this.isSMSenable = $event;
      this.alertService.updateAlert(`SMS ${$event ? 'Enabled' : 'Disabled'} Successfully`);
    });
  }

  ExportTOExcel() {
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'smsLogs.xlsx');
  }
}
